/**
 * GiftProductListContainer
 * --
 */
import React from 'react';
import GiftProductListPresenter from './GiftProductListPresenter';

const GiftProductListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <GiftProductListPresenter />
    </>
  );
};

export default GiftProductListContainer;
